export const Pay_Manual_Only = 83;
export const Pay_Rights = 61;
export const View_Pay = 84;
export const Remit_Rights = 33;
